<template>
  <div class="container mt-4">
    <h4 class="text-primary fw-bold mb-3">Gestionar Roles</h4>

    <!-- Buscador de Roles -->
    <div class="input-group mb-3">
      <input
        v-model="search"
        class="form-control"
        placeholder="Buscar rol..."
      />
      <button class="btn btn-primary" @click="search = ''">
        <font-awesome-icon icon="times" class="me-1" /> Limpiar
      </button>
    </div>


    <!-- Lista de Roles Existentes con Paginación -->
    <div class="card shadow-sm mb-3">
      <div class="card-header bg-light text-dark d-flex justify-content-between align-items-center">
        <span>Lista de Roles</span>
        <span>Página {{ currentPage }} de {{ totalPages }}</span>
      </div>
      <ul class="list-group list-group-flush">
        <li
          v-for="role in paginatedRoles"
          :key="role.id"
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          <span>{{ role.nombre }}</span>
          <button class="btn btn-danger btn-sm" @click="$emit('eliminar-role', role.id)">
            <font-awesome-icon icon="trash" class="me-1" /> Eliminar
          </button>
        </li>
      </ul>
      <div class="card-footer bg-light d-flex justify-content-between">
        <button class="btn btn-secondary btn-sm" @click="prevPage" :disabled="currentPage === 1">
          Anterior
        </button>
        <button class="btn btn-secondary btn-sm" @click="nextPage" :disabled="currentPage === totalPages">
          Siguiente
        </button>
      </div>
    </div>

    <!-- Formulario para Agregar Nuevo Rol -->
    <div class="card shadow-sm">
      <div class="card-header bg-light text-dark">Agregar Nuevo Rol</div>
      <div class="card-body">
        <div class="input-group">
          <input
            v-model="nuevoRole"
            class="form-control"
            placeholder="Nombre del nuevo rol"
          />
          <button class="btn btn-success" @click="crearNuevoRole">
            <font-awesome-icon icon="plus" class="me-1" /> Crear
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["roles"],
  data() {
    return {
      nuevoRole: "",
      currentPage: 1,
      itemsPerPage: 5, // Cambia según el número de elementos por página
      search: "",
    };
  },
  watch: {
    search(newVal) {
      this.currentPage = 1;
      this.$emit("search-role", newVal);
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.roles.length / this.itemsPerPage);
    },
    paginatedRoles() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.roles.slice(start, end);
    },
  },
  methods: {
    crearNuevoRole() {
      if (this.nuevoRole.trim()) {
        this.$emit("crear-role", this.nuevoRole.trim());
        this.nuevoRole = "";
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
}

h4 {
  font-weight: bold;
}

.card {
  border-radius: 8px;
  overflow: hidden;
}

.card-header {
  font-weight: bold;
}

.list-group-item {
  font-size: 1rem;
}

.text-primary {
  color: var(--app-primary) !important;
}

.table-hover tbody tr:hover {
  background-color: #f1f5f9;
}

.btn {
  margin: 0 5px;
}
</style>
